import http from './http'

function get (token) {
  return http({
    method: 'GET',
    url: '/sharing/' + token
  })
}

function open (token) {
  return http({
    method: 'GET',
    url: '/sharing/open/' + token,
    responseType: 'arraybuffer',
    // headers: {
    //   'Accept': 'application/pdf'
    // },
    timeout: Infinity
  })
}

function download (token) {
  return http({
    method: 'GET',
    url: '/sharing/download/' + token,
    responseType: 'blob',
    timeout: Infinity
  })
}

function meta (token) {
  return http({
    method: 'GET',
    url: '/sharing/meta/' + token
  })
}

export {
  get,
  open,
  meta,
  download
}



// WEBPACK FOOTER //
// ./src/services/api/share.js